// "Show amounts as": dollars, % of the account, points, ticks, R or Privacy, for the whole journal.
import { DISPLAY_MODES, setDisplayMode, useDisplayMode } from './display';
import InfoTip from './InfoTip';
import { useI18n } from './i18n';

export default function DisplaySwitch({ size }) {
  const { t } = useI18n();
  const mode = useDisplayMode();
  return (
    <label className={`display-switch${mode === 'privacy' ? ' is-private' : ''}`}>
      <span>{t('Show amounts as')}<InfoTip label={t('Show amounts as')}
        text={t('Changes how results show across your journal: in dollars, as a % of your account, in points or ticks (futures trades), in R (multiples of what you risked: set your usual risk in Settings), or hidden with Privacy, handy for screenshots and screen sharing.')} /></span>
      <select value={mode} onChange={(e) => setDisplayMode(e.target.value)}>
        {DISPLAY_MODES.map(([k, label]) => (
          <option key={k} value={k} disabled={k === 'pct' && !size}>
            {t(label)}{k === 'pct' && !size ? ` (${t('needs an account size')})` : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
